import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { setPageMeta, htmlToText } from "@/lib/seo";
import { QrCode, Loader2 } from "lucide-react";

export default function Policy() {
  const { slug } = useParams();
  const [policy, setPolicy] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPolicy(null); setNotFound(false);
    api.getPolicy(slug).then(setPolicy).catch(() => setNotFound(true));
  }, [slug]);

  useEffect(() => {
    if (policy) setPageMeta({
      title: `${policy.title} — DynaQR`,
      description: htmlToText(policy.content),
      canonical: `${window.location.origin}/policy/${slug}`,
    });
  }, [policy, slug]);

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 py-4">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="grid h-9 w-9 place-items-center rounded-xl bg-accent text-accent-foreground"><QrCode className="h-5 w-5" /></div>
            <span className="font-display text-xl font-extrabold tracking-tighter">DynaQR</span>
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 sm:px-6 py-12" data-testid="policy-page">
        {notFound ? (
          <p className="text-muted-foreground">Policy not found.</p>
        ) : !policy ? (
          <Loader2 className="h-6 w-6 animate-spin text-accent" />
        ) : (
          <>
            <h1 className="font-display text-3xl font-extrabold tracking-tighter mb-2">{policy.title}</h1>
            {policy.updated_at && <p className="text-xs text-muted-foreground mb-6">Last updated {new Date(policy.updated_at).toLocaleDateString()}</p>}
            <div className="policy-content text-sm leading-relaxed text-foreground/90 space-y-3"
              dangerouslySetInnerHTML={{ __html: policy.content }} />
          </>
        )}
        <div className="mt-10"><Link to="/" className="text-sm text-accent hover:underline">← Back to home</Link></div>
      </main>
    </div>
  );
}
